export const checkYoutubeLink = (url: string): string | null => {
  const regExp =
    /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/;
  const match = url.match(regExp);

  return match ? match[0] : null;
};
